/* KŌSMOPELLIS — galerie mobile : ligne de progression à la place des vignettes (≤749px).
   Additif : retirer la balise script dans sections/main-product.liquid pour désactiver. */
(function () {
  function setup(list) {
    if (list.dataset.kpProgress) return;
    list.dataset.kpProgress = '1';
    var items = list.querySelectorAll('.product__media-item');
    if (items.length < 2) return;
    var bar = document.createElement('div');
    bar.className = 'kp-gallery-progress';
    bar.setAttribute('role', 'progressbar');
    bar.setAttribute('aria-label', 'Position dans la galerie');
    bar.innerHTML = '<span class="kp-gallery-progress__fill"></span>';
    var host = list.closest('slider-component') || list;
    host.insertAdjacentElement('afterend', bar);
    var fill = bar.firstElementChild, raf = null;
    function update() {
      raf = null;
      // image active = celle dont le bord gauche est le plus proche de la position de scroll (snap Dawn)
      var base = items[0].offsetLeft, idx = 0, best = Infinity;
      items.forEach(function (it, i) { var d = Math.abs((it.offsetLeft - base) - list.scrollLeft); if (d < best) { best = d; idx = i; } });
      if (list.scrollLeft >= list.scrollWidth - list.clientWidth - 2) idx = items.length - 1; // bout de piste
      fill.style.width = ((idx + 1) / items.length) * 100 + '%';
      bar.setAttribute('aria-valuenow', idx + 1);
      bar.setAttribute('aria-valuemax', items.length);
    }
    list.addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }
  function init() { document.querySelectorAll('.product__media-list').forEach(setup); }
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
  document.addEventListener('shopify:section:load', init);
})();

/* Prix par patch sur les cartes Kaching : calculé à partir du prix affiché et du nombre de patchs
   écrit dans le sous-titre Kaching (« 8 patchs … »). Retirer ce bloc pour désactiver. */
(function () {
  function fmt(n) { return n.toFixed(2).replace('.', ',') + ' €'; }
  function apply() {
    document.querySelectorAll('.kaching-bundles__bars:not(.kaching-bundles__subscriptions) .kaching-bundles__bar').forEach(function (bar) {
      var sub = bar.querySelector('.kaching-bundles__bar-subtitle'), price = bar.querySelector('.kaching-bundles__bar-price');
      if (!sub || !price || sub.querySelector('.kp-unit')) return;
      var m = sub.textContent.match(/(\d+)\s*patchs?/i); if (!m) return;
      var p = parseFloat((price.textContent.match(/[\d\s]+,\d{2}/) || [''])[0].replace(/\s/g, '').replace(',', '.'));
      if (!p || !+m[1]) return;
      var span = document.createElement('span'); span.className = 'kp-unit'; span.textContent = '·\u00a0' + fmt(p / +m[1]).replace(' ', '\u00a0') + '/patch'; span.style.whiteSpace = 'nowrap';
      sub.appendChild(document.createTextNode(' ')); sub.appendChild(span);
    });
  }
  var t; function schedule() { clearTimeout(t); t = setTimeout(apply, 150); }
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  schedule();
})();

/* 20/09/2026 — Offre « 1 mois » présélectionnée à l'arrivée sur les fiches patch (demande d'Aris : un sticky à 99,90 €
   dès le 1er écran faisait fuir). Une seule fois, jamais après un choix de la visiteuse ; le Pack Visage n'est pas concerné.
   Retirer ce bloc pour revenir à la présélection définie dans Kaching. */
(function () {
  if (/cure-visage-complet/.test(location.pathname)) return;
  var done = false, touched = false;
  document.addEventListener('pointerdown', function (e) { if (e.isTrusted && e.target.closest && e.target.closest('.kaching-bundles__bar')) touched = true; }, true);
  function pick() {
    if (done || touched) return;
    var bars = document.querySelectorAll('.kaching-bundles__bars:not(.kaching-bundles__subscriptions) .kaching-bundles__bar');
    if (!bars.length) return;
    var target = null;
    bars.forEach(function (b) {
      if (target) return;
      var t = ((b.querySelector('.kaching-bundles__bar-title') || {}).textContent || '') + ' ' + ((b.querySelector('.kaching-bundles__bar-subtitle') || {}).textContent || '');
      if (/(^|[^0-9])1\s*mois/i.test(t)) target = b;
    });
    done = true;
    if (!target || target.classList.contains('kaching-bundles__bar--selected')) return;
    var el = target.querySelector('label.kaching-bundles__bar-container') || target.querySelector('input[type=radio]') || target;
    el.click();
  }
  var tries = 0, iv = setInterval(function () { tries++; if (document.querySelector('.kaching-bundles__bar--selected')) { clearInterval(iv); setTimeout(pick, 250); } else if (tries > 40) clearInterval(iv); }, 200);
})();
